// removed by extract-text-webpack-plugin
module.exports = {"language_selector":"styles__language_selector___3Cptq","language_dropdown":"styles__language_dropdown___2Bvvo","btn-icon":"styles__btn-icon___2OgXT","active":"styles__active___36Qvo","menu":"styles__menu___3-JQC","language_dropdown_container":"styles__language_dropdown_container___2YyN9","language_dropdown_menu":"styles__language_dropdown_menu___1SzCD","dropdown_item":"styles__dropdown_item___25cCN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/language-selector/styles.scss
// module id = 513
// module chunks = 0